import Box from '@zenbusiness/zui/Box';
import ZuiIconButton from '@zenbusiness/zui/IconButton';
import { styled } from '@zenbusiness/zui/styles';

export const Carousel = styled(Box)({
  overflow: 'hidden'
});

export const Container = styled(Box)({
  display: 'flex'
});

export const Slide = styled(Box)({
  fex: '0 0 100%',
  maxWidth: '100%',
  minWidth: '100%',
  margin: '0 0.5rem'
});

export const Controls = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  padding: `0 ${theme.spacing(1.5)}`,
  gap: theme.spacing(2)
}));

export const PrevButtonContainer = styled(Box)(({ theme }) => ({
  minWidth: 'unset',

  [theme.breakpoints.up('sm')]: {
    minWidth: '6.5rem'
  }
}));

export const ProgressBarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  padding: `0 ${theme.spacing(1)}`
}));

export const NextButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  minWidth: 'unset',
  gap: '0.5rem',

  [theme.breakpoints.up('sm')]: {
    minWidth: '6.5rem'
  }
}));

export const IconButton = styled(ZuiIconButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.dark,
  borderRadius: theme.shape.rounded.full,
  width: '3rem',
  height: '2.25rem'
}));
